import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import { REPORTS } from "@/constants/testIds";
import PeriodSelector from "@/components/reports/PeriodSelector";
import RevenueTab from "@/components/reports/RevenueTab";
import ServicesTab from "@/components/reports/ServicesTab";
import OccupancyTab from "@/components/reports/OccupancyTab";
import ClientsTab from "@/components/reports/ClientsTab";
import NoShowsTab from "@/components/reports/NoShowsTab";
import InventoryConsumptionTab from "@/components/reports/InventoryConsumptionTab";
import ProfessionalDashboard from "@/components/dashboard/ProfessionalDashboard";

/** Reportes de negocio: para Admin, 6 tabs con desglose y exportacion a
 * Excel/CSV. Profesional ve su vista reducida (misma que el Dashboard),
 * sin cifras financieras globales. Recepcion no tiene acceso a esta ruta. */
export default function ReportsPage() {
  const { user } = useAuth();
  const [period, setPeriod] = useState({ period: "month", start: "", end: "" });

  // Fix AW (2026-10-27): antes todo el que no era admin veia la vista de profesional;
  // ahora solo la profesional (un rol personalizado con Reportes ve las 6 pestañas).
  if (user?.role === "professional") {
    return <ProfessionalDashboard />;
  }

  return (
    <div className="space-y-6" data-testid={REPORTS.page}>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-3xl sm:text-4xl tracking-tight text-foreground">Reportes</h1>
          <p className="text-base text-muted-foreground mt-1">Ingresos, servicios, ocupación, clientes, no-shows e inventario.</p>
        </div>
        <PeriodSelector value={period} onChange={setPeriod} />
      </div>

      <Tabs defaultValue="revenue" className="w-full">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="revenue" data-testid={REPORTS.tabRevenue}>Ingresos</TabsTrigger>
          <TabsTrigger value="services" data-testid={REPORTS.tabServices}>Servicios</TabsTrigger>
          <TabsTrigger value="occupancy" data-testid={REPORTS.tabOccupancy}>Ocupación</TabsTrigger>
          <TabsTrigger value="clients" data-testid={REPORTS.tabClients}>Clientes</TabsTrigger>
          <TabsTrigger value="no-shows" data-testid={REPORTS.tabNoShows}>No-shows</TabsTrigger>
          <TabsTrigger value="inventory" data-testid={REPORTS.tabInventory}>Inventario</TabsTrigger>
        </TabsList>

        <TabsContent value="revenue" className="pt-6"><RevenueTab period={period} /></TabsContent>
        <TabsContent value="services" className="pt-6"><ServicesTab period={period} /></TabsContent>
        <TabsContent value="occupancy" className="pt-6"><OccupancyTab period={period} /></TabsContent>
        <TabsContent value="clients" className="pt-6"><ClientsTab period={period} /></TabsContent>
        <TabsContent value="no-shows" className="pt-6"><NoShowsTab period={period} /></TabsContent>
        <TabsContent value="inventory" className="pt-6"><InventoryConsumptionTab period={period} /></TabsContent>
      </Tabs>
    </div>
  );
}
